import { mixed, object, string } from "yup";

import { YesNo } from "@covertree/types";
import { nonEmptyString } from "@covertree/utils";
import { SourceOfDamageWeather } from "@api/operations.generated";

import {
  injuredPeopleValidation,
  InjuredPeopleFormPart,
} from "../shared/InjuredPersonsSection/form";

interface WeatherAndPropertyDamageFormPart {
  claimType: SourceOfDamageWeather | null;
  claimDescription: string;
  isDamageFixed: YesNo;
}

export type WeatherOrPropertyDamageForm = InjuredPeopleFormPart &
  WeatherAndPropertyDamageFormPart;

export const validation = object({
  claimType: string().required("Source of Damage is required"),
  claimDescription: nonEmptyString("Claim description").max(
    3000,
    "Claim description is too long"
  ),
  isDamageFixed: mixed<YesNo>()
    .oneOf(Object.values(YesNo), "Answer to the marked question is required")
    .required(),
  ...injuredPeopleValidation,
});
